module.exports = __webpack_public_path__ + "img/icon-confirmation.eebaef05.svg";